<template>
  <div class="xubio-libraries">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://xubio.com/" target="_blank">
            <h4 class="client">Xubio LLC</h4>
          </a>
          <h1 class="title">
            {{ $t("libraries.title") }}
          </h1>
          <p class="date">
            {{ $t("libraries.duration.title") }}
            {{ $t("libraries.duration.date") }}
          </p>
          <p class="role">
            {{ $t("libraries.position.title") }}
            {{ $t("libraries.position.role") }}
          </p>
          <p class="description">
            {{ $t("libraries.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("libraries.bullet1") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("libraries.bullet2") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("libraries.bullet3") }}
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img src="@/assets/libraries.jpg" alt="" class="demo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "animate.css";
import WOW from "wow.js";

export default {
  name: "XubioLibraries",
  components: {},
  mounted() {
    new WOW().init();
  },
};
</script>
<style lang="scss" scoped>
div.xubio-libraries {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 0;

  @media (min-width: 600px) {
    padding: 0;
    height: 100vh;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      font-weight: bold;
      color: gray;
      //margin-bottom: 0.5rem;
    }

    h1.title {
      font-family: "Raleway";
      text-align: left;
    }

    p.description {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #000;
      font-size: 1.2rem;
    }

    ul {
      font-family: "Raleway";
      list-style: inside;
      li {
        text-align: left;
        margin: 1rem 0;
        // font-weight: 500;
      }
    }
  }

  div.multimedia-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 50%;
      //box-shadow: 3px 3px 38px 7px #000;
    }
  }
}
</style>
